import { createUserManager } from 'redux-oidc';
import { IDENTITY_CONFIG } from './authConst';

const UserManager = createUserManager(IDENTITY_CONFIG);

export default UserManager;